import { FC } from 'react'
import { IoMdArrowBack } from 'react-icons/io'
import { IoSunny } from 'react-icons/io5'
import CustomText from '../../CustomText'
import { DateTime } from 'luxon'
import HeadingView from '../HeadingView/HeadingView'
import BackButton from '../BackButton/BackButton'
import InfoView from '../InfoView/InfoView'
import CheckListItem from '../ChecklistItem/CheckListItem'
import { Button, Flex } from '@chakra-ui/react'
import { UserProperty } from '../../../generated/graphql'
import { useAuthContext } from '../../../context/AuthProvider'
import { NewCustomerType } from '../../../types'

type ReviewSendViewProps = {
  isLoading: boolean
  stepCount: number
  totalStep: number
  title: string
  description: string
  handleBack: () => void
  handleNext: () => void
  activeProperty?: UserProperty
  newCustomer?: NewCustomerType
}

export const ReviewSendView: FC<ReviewSendViewProps> = ({
  isLoading,
  stepCount,
  totalStep,
  title,
  description,
  handleBack,
  handleNext,
  activeProperty,
  newCustomer
}: ReviewSendViewProps) => {
  const { user } = useAuthContext()

  console.log(`newCustomer: `, newCustomer)

  return (
    <div className={`w-full h-auto flex flex-col gap-y-4`}>
      <HeadingView
        stepCount={stepCount}
        totalStep={totalStep}
        title={title}
        description={description}
      />

      <div className="w-full h-auto flex flex-col gap-y-[25px] bg-white rounded-[32px] shadow-sm border-solid border-[1.5px] border-[#e4e4e4] p-[32px]">
        <div className="w-full h-auto bg-[#f9efc296] rounded-[40px] flex flex-row p-[24px]">
          <div className="grow h-full">
            <CustomText
              textLabel={'BILLING SWITCHES ON'}
              fontWeight={`font-regular`}
              fontSize="text-[16px]"
              fontColor={`text-black`}
            />
            <CustomText
              textLabel={`${DateTime.fromISO(newCustomer?.transferDate as string).toFormat('dd LLLL yyyy')}`}
              fontWeight={`font-bold`}
              fontSize="text-[24px]"
              fontColor={`text-black`}
            />
          </div>
          <div className="w-[60px] h-[60px] bg-[#FFD200] flex flex-row items-center justify-center rounded-full">
            <IoSunny className="w-[32px] h-[32px]" color="#ffffff" />
          </div>
        </div>
        <div className="w-full h-auto flex flex-row gap-x-[24px]">
          <InfoView
            label={'CURRENT OWNER'}
            name={`${user?.info?.firstName} ${user?.info?.lastName}` || ''}
            email={`${user?.info?.email}` || ''}
            mobile={`${user?.info?.contactNumber}` || ''}
            idNumber={`${user?.info?.idPassportNumber}` || ''}
            account={`#${activeProperty?.orderNumber}` || ''}
            property={activeProperty?.fullAddress || ''}
          />
          <InfoView
            label={'NEW OWNER'}
            name={`${newCustomer?.firstName} ${newCustomer?.lastName}` || ''}
            email={`${newCustomer?.email}` || ''}
            mobile={`${newCustomer?.contactNumber}` || ''}
            idNumber={`${newCustomer?.idNumber}` || ''}
            account={`#${activeProperty?.orderNumber}` || ''}
            property={activeProperty?.fullAddress || ''}
            handleEdit={handleBack}
          >
            <div className="w-full h-auto flex flex-row justify-between">
              <CustomText
                textLabel={`Move date`}
                fontWeight={`font-regular`}
                fontSize="text-[12px]"
                fontColor={`text-black`}
              />
              <CustomText
                textLabel={`${DateTime.fromISO(newCustomer?.transferDate as string).toFormat('dd LLLL yyyy')}`}
                fontWeight={`font-bold`}
                fontSize="text-[14px]"
                fontColor={`text-black`}
              />
            </div>
          </InfoView>
        </div>
        <div className="w-full h-auto flex flex-col gap-y-4">
          <CheckListItem description={"We'll email a unique onboarding link to the new owner"} />
          <CheckListItem
            description={'Your subscription stays active right up to the switch date'}
          />
          <CheckListItem description={"We'll send you a confirmation summary by email"} />
        </div>
      </div>

      <Flex
        direction={['column', 'column', 'row', 'row']}
        justifyContent={'space-between'}
        alignItems={'center'}
        gap={['25px', '25px', '25px', '10%']}
      >
        <div className="w-fit h-fit flex flex-row justify-between">
          <BackButton label="Back" handleClick={handleBack} isBack={false}>
            <IoMdArrowBack className="w-[20px] h-[20px]" color="#000000" />
          </BackButton>
        </div>

        <Flex w="100%" h="100%" alignItems={'center'} justifyContent="flex-end">
          <Button
            variant={'dark'}
            isLoading={isLoading}
            onClick={handleNext}
            type="submit"
            mt="15px"
          >
            Send invite
          </Button>
        </Flex>
      </Flex>
    </div>
  )
}

export default ReviewSendView
